var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "@simonwep/pickr", "./StyleTool", "../domutils"], function (require, exports, pickr_1, StyleTool_1, domutils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ColorPicker = void 0;
    pickr_1 = __importDefault(pickr_1);
    class ColorPicker extends StyleTool_1.StyleTool {
        constructor(viewer, id, defaultValue, changeHandler) {
            super(viewer, id, defaultValue, changeHandler);
            this.initPickr = () => {
                this.btn = document.createElement('div');
                this.btn.style.backgroundColor = this.defaultValue;
                domutils_1.addClass(this.btn, 'color-picker');
                const pickr = pickr_1.default.create({
                    el: this.btn,
                    theme: 'nano',
                    useAsButton: true,
                    default: this.defaultValue,
                    swatches: [
                        'rgba(255, 0, 0, 1)',
                        'rgb(104,144,1)',
                        'rgb(16,63,251)',
                        'rgba(146, 40, 144, 1)',
                        'rgba(254, 249, 53, 1)',
                        'rgba(255, 146, 36, 1)',
                        'rgba(3, 252, 254, 1)',
                        'rgba(255, 76, 252, 1)',
                        'rgba(0, 247, 44, 1)',
                        'rgba(0, 0, 0, 1)',
                        'rgba(255, 255, 255, 1)',
                    ],
                    components: {
                        // Main components
                        preview: true,
                        opacity: false,
                        hue: true,
                        // Input / output Options
                        interaction: {
                            hex: false,
                            rgba: false,
                            hsla: false,
                            hsva: false,
                            cmyk: false,
                            input: false,
                            clear: false,
                            save: false,
                        },
                    },
                });
                pickr.on('change', this.changeColorHandler);
            };
            this.changeColorHandler = (color, source, instance) => {
                const colorHexa = color.toHEXA().toString();
                if (this.btn) {
                    this.btn.style.backgroundColor = colorHexa;
                }
                this.changeHandler(colorHexa);
            };
            // @ts-ignore
            this.initPickr();
        }
        // initializeBar = (defaultColor: string): HTMLElement => {
        //     let div = document.createElement('div');
        //     addClass(div, 'color-picker-bar');
        //     div.style.backgroundColor = defaultColor;
        //     // @ts-ignore
        //     this.container.appendChild(div);
        //     return div;
        // }
        getTool() {
            return this.btn;
        }
    }
    exports.ColorPicker = ColorPicker;
});
//# sourceMappingURL=ColorPicker.js.map